var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80019 4.39995C6.37014 4.39995 4.4002 6.3699 4.4002 8.79995C4.4002 11.23 6.37014 13.2 8.80019 13.2C11.2302 13.2 13.2002 11.23 13.2002 8.79995C13.2002 6.3699 11.2302 4.39995 8.80019 4.39995ZM2.2002 8.79995C2.2002 5.15487 5.15512 2.19995 8.80019 2.19995C12.4453 2.19995 15.4002 5.15487 15.4002 8.79995C15.4002 10.2254 14.9483 11.5452 14.18 12.6241L19.478 17.9221C19.9076 18.3517 19.9076 19.0482 19.478 19.4778C19.0484 19.9073 18.352 19.9073 17.9224 19.4778L12.6244 14.1798C11.5455 14.9481 10.2256 15.4 8.80019 15.4C5.15512 15.4 2.2002 12.445 2.2002 8.79995Z",
    fill: "#3EB0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.301ec3dd7d8edeaf4106ccfb045a8da3.svg";
export { ForwardRef as ReactComponent };